import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { ClientLayoutComponent } from './client-layout.component';
import { UserDropdownComponent } from './user-dropdown/user-dropdown.component';

@NgModule({
  imports: [
    SharedModule,
  ],
  declarations: [
    ClientLayoutComponent,
    UserDropdownComponent,
  ],
  exports: [
    ClientLayoutComponent,
  ],
})
export class ClientLayoutModule {}



// WEBPACK FOOTER //
// ./src/app/layouts/client/client-layout.module.ts